import { EditComponentProps } from "@material-table/core";
import { SInputProps } from "components/parts";
import { SCode } from "messages/codes";
import Select, { Props as SelectProps, StylesConfig } from "react-select";

type Props = Partial<Omit<SelectProps, "value" | "type">> &
  Pick<SInputProps, "disabled"> &
  Partial<{
    empty: boolean;
  }> & {
    editProps: EditComponentProps<any>;
    value: SCode | undefined;
    options: SCode[];
  };

export const SCodeSelectCell = ({
  editProps,
  value,
  defaultValue,
  options,
  empty,
  ...props
}: Props): JSX.Element => {
  let styles: StylesConfig = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menu: (base) => ({
      ...base,
    }),
    control: (base) => ({
      ...base,
      fontSize: "0.8rem",
      borderRadius: "0px",
      height: "24px",
      minHeight: "24px",
    }),
    clearIndicator: (base) => ({
      ...base,
      margin: "0px",
      padding: "2px",
      paddingTop: "5px",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      margin: "0px",
      padding: "2px",
      paddingTop: "5px",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "20px",
      minHeight: "20px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      width: "0px",
      height: "0px",
      minHeight: "0px",
      margin: "0px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "20px",
      minHeight: "20px",
      padding: "0px",
    }),
    singleValue: (base) => ({
      ...base,
      margin: "0px",
      paddingLeft: "4px",
      paddingTop: "0px",
      paddingBottom: "0px",
    }),
    input: (base) => ({
      ...base,
      margin: "0px",
      paddingLeft: "4px",
      paddingTop: "0px",
      paddingBottom: "0px",
    }),
  };

  return (
    <Select
      {...props}
      value={value}
      options={options}
      onBlur={(event) => {
        props.onBlur?.call(this, event);
      }}
      onChange={(newValue, actionMeta) => {
        editProps.onChange(newValue);
        props.onChange?.call(this, newValue, actionMeta);
      }}
      isDisabled={props.disabled}
      getOptionLabel={(option) => {
        const item = option as SCode;
        return `${item?.value}: ${item?.label}`;
      }}
      isClearable={empty}
      tabIndex={0}
      placeholder={null}
      backspaceRemovesValue
      closeMenuOnSelect
      styles={styles}
      menuPortalTarget={document.body}
    />
  );
};
